// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Kd_eT{padding:14px;padding-bottom:2px}.U9k4t{display:flex;height:16px;width:100%;border-radius:8px;overflow:hidden}.sLDlG:hover{filter:brightness(1.1)}.i2BNP{height:32px}._Dbie{height:40px}.giiDB{display:flex;align-items:center;gap:8px}.HSSnC{width:16px;height:16px;border-radius:50%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invoiceBarContainer": `Kd_eT`,
	"invoiceBarContent": `U9k4t`,
	"invoiceBarPercentage": `sLDlG`,
	"sixItemsInvoiceInfoRow": `i2BNP`,
	"lessThanSixItemsInvoiceInfoRow": `_Dbie`,
	"dotContainer": `giiDB`,
	"dot": `HSSnC`
};
export default ___CSS_LOADER_EXPORT___;
